export { default } from '@shikijs/langs/wgsl'
